<template>
  <funding-base :state="state">
    <div class="container">
      funding pot settings
    </div>
  </funding-base>
</template>

<script>
export default {
  name: 'FundingView'
}
</script>